import { render } from "./ChoiceGridTypeComponent.vue?vue&type=template&id=9c4e0af6&scoped=true"
import script from "./ChoiceGridTypeComponent.vue?vue&type=script&lang=js"
export * from "./ChoiceGridTypeComponent.vue?vue&type=script&lang=js"

import "./ChoiceGridTypeComponent.vue?vue&type=style&index=0&id=9c4e0af6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c4e0af6"]])

export default __exports__